import { render, staticRenderFns } from "./SnapshotsCache.vue?vue&type=template&id=3181d728&scoped=true&"
import script from "./SnapshotsCache.vue?vue&type=script&lang=js&"
export * from "./SnapshotsCache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3181d728",
  null
  
)

export default component.exports